import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AdministrarFuncionariosComponent } from './administrar-funcionarios.component';
import { ConsultaFuncionarioComponent } from './consulta-funcionarios/consulta-funcionario.component';
import { AuthGuard } from 'src/app/shared/guards/authGuard/auth.guard';

const routes: Routes = [
    { path: '', component: ConsultaFuncionarioComponent },
    { path: 'registro', component: AdministrarFuncionariosComponent, canActivate: [AuthGuard] }
  ];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class AdministrarFuncionariosRoutingModule { }
